module.exports = __webpack_public_path__ + "img/collapseArrow.ab983d07.svg";